// extracted by mini-css-extract-plugin
module.exports = {"main":"TableCells_main__3YuWi","list":"TableCells_list__1Tni3","firstItemBold":"TableCells_firstItemBold__3NsFv","link":"TableCells_link__yur8_"};